import type { Profile } from '@/modules/sanr-api';

// The Score backend records one of its own accounts as the inviter of every
// demo throwaway account, one per SSO demo kind — the stand's operator-minted
// accounts (`demo_private`, DEMO_INVITER_ISSUER_ID) and the event QR code's
// self-served ones (`demo_public`) — and nobody else is invited by either, so
// the match is the app's only demo marker: the profile carries no email and
// the demo username is a cosmetic word pair.
const DEMO_INVITER_IDS: ReadonlySet<string | null | undefined> = new Set([
  '724017a2-fd4b-4822-ae44-243a6f9f9760',
  '820bb2cb-7b83-43bd-9d36-ab7bd246015b',
]);

export function isDemoAccount(profile: Pick<Profile, 'invitedBy'>): boolean {
  return DEMO_INVITER_IDS.has(profile.invitedBy);
}
